export { default } from './FeeRecommendationsPanel';
